import { LoggerConfig } from 'ngx-logger';
import { TcLoggerConfigInterface } from './tc-logger-config.interface';

export class TcLoggerConfig
  extends LoggerConfig
  implements TcLoggerConfigInterface {}
